<!-- Show TVSpot thumbnail with optional social media icons on top. -->

<template>
  <div style="position: relative">
    <img
      :src="thumbnailUrl"
      class="video-thumbnail"
      :class="{
        'video-thumbnail--outline-on-hover': outlineOnHover,
        'video-thumbnail--outlined': outlined,
      }"
    >
    <span v-if="tvspot.tvformat.is_socialmedia_format">
      <img
        v-for="(platformIconUrl, platformIconIndex) in tvspot.tvformat
          .socialmedia_icon_urls"
        :key="platformIconUrl"
        :src="platformIconUrl"
        width="20"
        height="20"
        style="position: absolute; left: -12px"
        :style="{top: -6 + platformIconIndex * 20 + 'px'}"
      >
    </span>
  </div>
</template>

<script>
export default {
  props: {
    tvspot: {
      type: Object,
      required: true,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    outlineOnHover: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    thumbnailUrl() {
      return this.tvspot.thumbnail_url;
    },
  },
};
</script>

<style scoped>
img.video-thumbnail {
  outline: 1px solid rgba(0, 0, 0, 0.16);
}
img.video-thumbnail.video-thumbnail--outlined,
img.video-thumbnail.video-thumbnail--outline-on-hover:hover {
  outline: 2px solid var(--msr-color-primary);
}
</style>



// WEBPACK FOOTER //
// src/components/VideoThumbnail.vue